module.exports = __webpack_public_path__ + "static/media/podium 1.0b7e5c84.svg";